import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import ProjectModuleModel from '@/views/Project/Project/models/projectModule'
import ProjectModel from '@/views/Project/Project/models/project'
import ProjectMixin from '@/_mixins/project'

@Component({
    inheritAttrs: false,
    name: 'module-patch',
    components: { DialogTemplate },
    mixins: [ProjectMixin],
})
export default class ModulePatch extends Mixins<MixinInterface & ProjectMixin>() {
    @Prop({ required: true }) props!: any
    @Prop({}) enterPressed!: number

    get status(): string {
        return this.props.status
    }

    get project(): ProjectModel {
        return this.props.project
    }

    get projectModule(): ProjectModuleModel {
        return this.props.projectModule
    }

    get moduleToBeArchived() {
        const accessModuleId = 'access'
        const personnelModuleId = 'personnel'
        const accessModule = this.project.getModule(accessModuleId)
        const personnelModule = this.project.getModule(personnelModuleId)

        return {
            [personnelModuleId]: {
                relatedModule: {
                    id: accessModule?.module._id,
                    isActive: accessModule?.status === 'active',
                    canArchive: accessModule?._constraints?.status.whitelist?.includes('closed'),
                    projectModule: accessModule,
                },
            },
            [accessModuleId]: {
                relatedModule: {
                    id: personnelModule?.module._id,
                    isActive: personnelModule?.status === 'active',
                    canArchive: personnelModule?._constraints?.status.whitelist?.includes('closed'),
                    projectModule: personnelModule,
                },
            },
        }
    }

    loading = false
    error = false
    deleteCodeTxt = ''
    archiveRelatedModule = false

    disableDeleteCode() {
        const moduleName: string = this.$t(
            `project_modules.${this.projectModule.module._id}`
        ).toString()
        return (
            !this.deleteCodeTxt ||
            this.deleteCodeTxt.toLowerCase().trim() !== moduleName.toLowerCase().trim()
        )
    }

    async patch() {
        let prevStatus = this.projectModule.status
        if (!(this.status === 'deleted' && this.disableDeleteCode())) {
            this.loading = true
            let projectModule = await this.projectModule.patch(this.status).catch(async (error) => {
                error = true
            })
            if (this.archiveRelatedModule && this.projectModule.module._id) {
                const module = this.moduleToBeArchived[this.projectModule.module._id]
                if (module && module.relatedModule.canArchive) {
                    await module.relatedModule.projectModule.patch('closed').catch((error) => {
                        error = true
                    })
                }
            }

            if (projectModule) {
                this.$emit('close', projectModule)
            }

            // If project module has been deleted, admin permissions are removed
            // Since it's 2 different API it takes a second to update permissions after the module is restored
            // if status changed from deleted to anything else update project with the delay
            // It's possibly temporary solution

            if (prevStatus === 'deleted' && this.status !== 'deleted') {
                setTimeout(async () => {
                    await this.getProject(this.$route.params.id)
                    this.loading = false
                }, 1000)
            }
        }
    }
}
